<template>
  <SlickList
    lockAxis="y"
    :useDragHandle="true"
    v-model="question.options">
    <SlickItem
      v-for="(option, optionIndex) in question.options"
      :index="optionIndex"
      :key="option.id">
      <div class="form-sortable py-1 justify-between flex align-center relative px-4">
        <div class="form-sortable__left flex align-center lg:col-6 md:col-7">
          <OptionDrawIcon
            :type="question.type"
          />
          <SmartInput
            class="w-full"
            v-model="option.value"
            @change="setOptionValueWhenEmpty(optionIndex, option.value)"
          />

          <SmartInput
            style="width:80px"
            type="tel"
            placeholder="Peso"
            mask="###"
            v-model.number="option.load"
          />
        </div>
        <OptionActions
          :currentEvidence="option.evidence"
          :showRemove="canShowRemove(question)"
          :currentSelection="currentSelection"
          :question="question"
          @remove="removeOption(questionIndex, optionIndex)"
          @evidence="option.evidence = $event">
          <template v-slot:sortable>
            <SmartIcon
              v-handle
              name="sortable"
              class="form-sortable__icon text-opacity-md"
              :size="2"
            />
          </template>
        </OptionActions>
      </div>
    </SlickItem>
    <div
      v-show="question.hasOtherOption"
      class="py-1 justify-between flex align-center relative px-4 form-sortable">
      <div class="form-sortable__left flex align-center lg:col-6">
        <OptionDrawIcon
          :type="question.type"
        />
        <SmartInput
          class="w-full form-input--dotted"
          placeholder="Outro..."
          readonly
          disabled
        />
      </div>
      <OptionActions
        :has-evidence="false"
        :show-remove="true"
        @remove="question.hasOtherOption = false"
      />
    </div>
    <div
      v-if="question.type === 'INPUT'"
      class="py-1 justify-between flex align-center relative px-4 form-sortable">
      <div class="form-sortable__left flex align-center lg:col-6">
        <OptionDrawIcon
          :type="question.type"
        />
        <SmartInput
          class="w-full form-input--dotted"
          placeholder="Resposta..."
          readonly
          disabled
        />
      </div>
    </div>
    <div
      v-else-if="question.type === 'PICTURE'"
      class="py-1 justify-between flex align-center relative px-4 form-sortable">
      <div class="form-sortable__left flex align-center lg:col-6">
        <OptionDrawIcon
          :type="question.type"
        />
        <SmartInput
          class="w-full form-input--dotted"
          placeholder="Imagem..."
          readonly
          disabled
        />
      </div>
    </div>
    <div
      v-else
      class="py-1 justify-between flex align-center relative px-4 form-sortable">
      <div
        class="form-sortable__left flex align-center lg:col-6 md:col-7"
        v-show="question.id === currentSelection">
        <OptionDrawIcon
          :type="question.type"
        />
        <QuestionAdd
          :has-other-option="question.hasOtherOption"
          class="mx-1"
          @click.self="addOption(question)"
          @addOther="addOtherOption(question)"
        />
      </div>
    </div>

    <QuestionFooter
      v-show="question.id === currentSelection"
      @delete="deleteCurrentQuestion"
      @copy="cloneCurrentQuestion(questionIndex)"
      @newQuestion="createNewQuestion(questionIndex)"
    />
  </SlickList>
</template>

<script>
// @flow
import { SlickList, SlickItem, HandleDirective } from 'vue-slicksort';
import { copy } from 'utils';

import {
  createQuestion,
  createOption, currentOptionID,
  addQuestionID
} from '../functions';

export default {
  directives: { handle: HandleDirective },
  props: {
    questions: {
      type: Array,
      required: true
    },
    currentSelection: {
      type: Number,
      required: true
    },
    questionIndex: {
      type: Number,
      required: true
    }
  },
  components: {
    QuestionFooter: () => import('./question/QuestionFooter'),
    QuestionAdd: () => import('./question/QuestionAdd'),
    OptionDrawIcon: () => import('./option/OptionDrawIcon'),
    OptionActions: () => import('./option/OptionActions'),
    SlickList,
    SlickItem
  },
  computed: {
    question() {
      const STANDARD_QUESTION = { options: [] };

      return this.questions[this.questionIndex] || STANDARD_QUESTION;
    }
  },
  methods: {
    canShowRemove(question: SmartQuestion) {
      return question.options.length > 1 && question.id === this.currentSelection;
    },

    // QUESTIONS
    createNewQuestion(index: number = -1) {
      const nextIndex = index + 1;
      this.questions.splice(nextIndex, 0, createQuestion(nextIndex));

      this.emitSelection(this.questions[nextIndex].id);
    },
    deleteCurrentQuestion() {
      let currentIndex = this.questionIndex;
      this.questions.splice(currentIndex, 1);

      if (currentIndex === 0) { currentIndex = 1; }
      const question = this.questions[currentIndex - 1];

      if (question) {
        this.emitSelection(question.id);
      }
    },
    cloneCurrentQuestion(index: number) {
      const nextIndex = index + 1;
      const newID = addQuestionID();

      const question = {
        ...this.question,
        id: newID,
        options: copy(this.question.options)
      };

      this.questions.splice(nextIndex, 0, question);
      this.emitSelection(newID);
    },

    // OPTIONS
    addOption() {
      const currentLength = this.question.options.length;

      this.question.options.push(
        createOption(currentLength + 1)
      );

      this.emitSelection(currentOptionID());
    },

    removeOption(questionIndex: number, optionIndex: number) {
      this.question.options.splice(optionIndex, 1);
    },

    // OTHER
    addOtherOption() {
      this.question.hasOtherOption = true;
    },

    emitSelection(id: number) {
      this.$emit('setCurrentSelection', id);
    },

    setOptionValueWhenEmpty(index: number, value: string) {
      if (value) { return; }
      this.question.options[index].value = `Opção ${index + 1}`;
    }
  }
};
</script>
